<template>
	<li class="draggable-item" :class="{ 'draggable-collapsable' : data.children.length > 0 }" :data-uuid="instance.uuid">
		<div class="item-content">

			<div>
				<div>
					<div class="handle">
						<div v-if="!instance.properties.url || instance.properties.url !== '/'" class="grip"></div>
					</div>
				</div>

				<template v-for="column in columns">
					<template v-if="instance.properties[column.name]">
						<template v-if='instance.properties[column.name][0] !== "None"'>
							<button class="btn-collapse fa fa-plus" :key="'0'+column.id" v-on:click="collapseToggleChangeHandler"></button>
							<span v-html="renderColumnField(instance, instances, markets, column, linkedEntity)" :key="column.id"></span>
						</template>
					</template>
					<template v-else>
						<span :key="column.id"></span>
					</template>
				</template>
			</div>

			<div>
				<div class="toggle-wrapper">
					<a href="#" class="btn-multi-switch" :class="`${ getMultiSwitchClass(instance.state) }`" :data-id="instance.id" v-on:click="stateToggleChangeHandler">
						<input type="number" name="state-toggle" :value="instance.state">
					</a>
				</div>

				<div class="toggle-wrapper" v-if="mainSlug === 'pages'">
					<a href="#" class="btn-switch red" :class="{ 'active' : instance.properties['hide-from-navigation'] === 'true' }" :data-id="instance.id" v-on:click="visibilityToggleChangeHandler"></a>
				</div>

				<div class="btns">
					<template v-if="mainSlug === 'pages'">
						<router-link v-if="permissions.edit" :to="`pages/${linkedEntity.entity.id}/edit/${instance.uuid}`"><i class="fa fa-pen"></i></router-link>
					</template>
					<template v-else>
						<router-link v-if="permissions.edit" :to="`${linkedEntity.entity.id}/edit/${instance.uuid}`"><i class="fa fa-pen"></i></router-link>
					</template>
					<a v-if="permissions.delete" href="#" class="btn-delete-confirm fa fa-trash-alt" :id="instance.uuid"></a>
				</div>
			</div>

		</div>

		<ul class="draggable-container">
			<ObjectOverviewItem v-for="childInstance in data.children"
				:key="childInstance.id"
				:data="childInstance"
				:instances="instances"
				:columns="columns"
				:markets="markets"
				:linkedEntity="linkedEntity"
				:mainSlug="mainSlug"
				:permissions="permissions"
				:collapseToggleChangeHandlerCallback="collapseToggleChangeHandler"
				:stateToggleChangeHandlerCallback="stateToggleChangeHandler"
				:visibilityToggleChangeHandlerCallback="visibilityToggleChangeHandler"
				ref="instanceElement"
			></ObjectOverviewItem>
		</ul>
	</li>
</template>

<script>

export default {
	name: 'ObjectOverviewItem',
	props: {
		data: Object,
		instances: Array,
		columns: Array,
		markets: Array,
		linkedEntity: Object,
		mainSlug: String,
		permissions: Object,
		collapseToggleChangeHandlerCallback: Function,
		stateToggleChangeHandlerCallback: Function,
		visibilityToggleChangeHandlerCallback: Function
	},

	data () {
		return {
			instance: null
		}
	},

	created () {
		this.findCorrectInstance()
	},

	updated () {
		// this.findCorrectInstance()
	},

	methods: {
		findCorrectInstance () {
			// find the correct instance for the given ID
			for (var i = this.instances.length - 1; i >= 0; i--) {
				if (this.instances[i].id === this.data.id) {
					this.instance = this.instances[i]
					break
				}
			}
		},

		collapseToggleChangeHandler (e) {
			this.collapseToggleChangeHandlerCallback(e)
		},

		stateToggleChangeHandler (e) {
			this.stateToggleChangeHandlerCallback(e)
		},

		visibilityToggleChangeHandler (e) {
			this.visibilityToggleChangeHandlerCallback(e)
		}
	}
}

</script>
